module.exports = __webpack_public_path__ + "static/media/bulk-upload.6dc0cac9.svg";